import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import { maxWidth, spacing } from '#/theme/theme';

/**
 * This route only appears when the user gets navigated to it from the client
 * after logging in.
 *
 * When logged in and hitting this page directly the user downloads the file immediately
 */
export default function ViewUserUploadHorizonRoute() {
  const { i18n } = useI18n();
  const location = useLocation();

  useEffect(() => {
    window.open(location.pathname, '_target');
  }, [location.pathname]);

  return (
    <div
      style={{
        maxWidth: maxWidth[3],
        margin: '0 auto',
      }}
    >
      <div style={{ padding: spacing[60] }}>
        <header>
          <h3>{i18n('Downloading...')}</h3>
          <p>
            {i18n(
              'If your download does not start automatically, please click the button below.',
            )}
          </p>
        </header>

        <Button
          type="link"
          download
          variant="primary"
          href={location.pathname}
          qaId="download-link"
        >
          {i18n('Download')}
        </Button>
      </div>
    </div>
  );
}
